<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.8997 14.1001C27.462 15.6628 28.3396 17.7821 28.3396 19.9918C28.3396 22.2015 27.462 24.3207 25.8997 25.8834M18.333 8.3335L9.99967 15.0002H3.33301V25.0002H9.99967L18.333 31.6668V8.3335Z" stroke="white" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
</svg>
